module.exports = __webpack_public_path__ + "static/media/business.becc7420.png";